import {
    ServerActionWidget,
    SPI,
    ActionWidget,
    ActionType,
    ClickResult,
    RuntimeServerAction,
    SubmitValue,
    ActiveRecord
} from '@kunlun/dependencies';
import { OioNotification } from '@kunlun/vue-ui-antd';


@SPI.ClassFactory(
    ActionWidget.Token({
        actionType: ActionType.Server,
        name: 'previewLetter',
        model: [
            'deli.aries.platform.DeliAriesPlatformSettlementBill',
            'deli.aries.seller.DeliAriesSellerSettlementBill',
            'deli.aries.merchant.DeliAriesMerchantSettlementBill',
            'deli.aries.platform.DeliAriesPlatformDisLetterBill',
            'deli.aries.seller.DeliAriesSellerDisLetterBill',
            'deli.aries.merchant.DeliAriesMerchantDisLetterBill'
        ]
    })
)
export class previewLetterBtnWidget extends ServerActionWidget {
    protected executeAction(action: RuntimeServerAction, submitValue: SubmitValue): Promise<ClickResult> {
        const submitValueCopy = { ...submitValue }
        submitValueCopy.records = this.activeRecords?.[0] ?? {}
        return super.executeAction(action, submitValueCopy);
    }

    protected clickActionAfter(result: ClickResult): Promise<ClickResult> {
        const obj = {
            previewUrl:null
        };
        Object.assign(obj, result);
        if(obj.previewUrl){
            window.open(obj.previewUrl)
        }
        return super.clickActionAfter(result);
    }
}
